const CHROMES = Object.freeze(["default", "none", "fill"]);
const DOCK_SIDES = Object.freeze(["", "top", "bottom", "left", "right"]);

export function frameLayoutFor({ chrome, dockSide }) {
  if (!CHROMES.includes(chrome)) {
    throw new Error(`[q3po] page chrome "${chrome}" is not one of ${CHROMES.join(", ")}; the frame cannot lay out the call dock`);
  }
  if (!DOCK_SIDES.includes(dockSide)) {
    throw new Error(`[q3po] call dock side "${dockSide}" is not one of ${DOCK_SIDES.filter(Boolean).join(", ")} (or "" for none)`);
  }
  if (chrome === "none") {
    return { showSlots: false, fillsViewport: false, pageColumnHeight: "fill", pageOverflow: undefined };
  }
  const docked = dockSide !== "";
  const fillPage = chrome === "fill";
  if (!docked && !fillPage) {
    return { showSlots: true, fillsViewport: false, pageColumnHeight: undefined, pageOverflow: undefined };
  }
  return { showSlots: true, fillsViewport: true, pageColumnHeight: "fill-remaining", pageOverflow: fillPage ? undefined : "auto" };
}

const SIDE_DOCKS = Object.freeze(["left", "right"]);
const NARROW_GUTTER_MAX_WIDTH = 768;

export function sideDockGutters({ dockSide, viewportWidth }) {
  if (!DOCK_SIDES.includes(dockSide)) {
    throw new Error(`[q3po] call dock side "${dockSide}" is not one of ${DOCK_SIDES.filter(Boolean).join(", ")} (or "" for none); the frame cannot place Starfield's gutters`);
  }
  if (!Number.isFinite(viewportWidth)) {
    throw new Error(`[q3po] side dock gutters need the viewport width, got viewport width ${viewportWidth}`);
  }
  if (!SIDE_DOCKS.includes(dockSide)) {
    return { bareStarfield: false, pagePadding: null };
  }
  return { bareStarfield: true, pagePadding: viewportWidth <= NARROW_GUTTER_MAX_WIDTH ? "small" : "huge" };
}
